module.exports = __webpack_public_path__ + "img/mos-swiper-pc1.fff49b7c.png";